module.exports = __webpack_public_path__ + "static/img/banner_solutions_ime.f254c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_ime.png
// module id = 8B4u
// module chunks = 10